import {Calculation} from "../../../../../swaggerServices";

export enum BlockType {
  Start = "Start",
  Function = "Function",
  Decision = "Decision",
  Warning = "Warning",
  Value = "Value",
  End = "End",
  Placeholder = "Placeholder",
}

export interface DocumentationType {
  desc?: string;
  numArgs?: string;
  input?: string;
  formula?: string;
}

export interface Block extends Calculation {
  id: string;
  name: string;
  description: string;
  documentation: DocumentationType;
  type: BlockType;
}
